import axios from "axios";
import { create } from "zustand";
import Cookies from "js-cookie";

const addressStore = create((set) => ({
  myAddress: null,
  selectedAddress: null,
  isLoading: true,

  AddressForm: {
    fullName: "",
    phoneNumber: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    country: "India",
    addressCategory: "home",
    useDefault: false,
  },

  setIsLoading: ({ value }) => {
    set({ isLoading: value });
  },

  setMyAddressNull: () => {
    set({ myAddress: null });
  },

  validationAddressForm: {
    fullName: false,
    phoneNumber: false,
    address: false,
    city: false,
    state: false,
    pincode: false,
  },

  setAddressForm: (e) => {
    const { name, value } = e.target;
    set((state) => {
      return {
        AddressForm: {
          ...state.AddressForm,
          [name]: value,
        },
      };
    });
  },

  setUseDefault: ({ value }) => {
    set((state) => {
      return {
        AddressForm: {
          ...state.AddressForm,
          useDefault: value,
        },
      };
    });
  },

  setValidationAddressForm: ({ name, value }) => {
    set((state) => {
      return {
        validationAddressForm: {
          ...state.validationAddressForm,
          [name]: value,
        },
      };
    });
  },

  clearAddressForm: () => {
    set({
      AddressForm: {
        fullName: "",
        phoneNumber: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        country: "India",
        addressCategory: "home",
        useDefault: false,
      },
      validationAddressForm: {
        fullName: false,
        phoneNumber: false,
        address: false,
        city: false,
        state: false,
        pincode: false,
      },
    });
  },

  checkValidation: () => {
    const { AddressForm, setValidationAddressForm } = addressStore.getState();
    let flag = 0;
    if (AddressForm.fullName === "") {
      setValidationAddressForm({ name: "fullName", value: true });
      flag++;
    } else {
      setValidationAddressForm({ name: "fullName", value: false });
    }
    if (AddressForm.phoneNumber === "") {
      setValidationAddressForm({ name: "phoneNumber", value: true });
      flag++;
    } else {
      setValidationAddressForm({ name: "phoneNumber", value: false });
    }
    if (AddressForm.address === "") {
      setValidationAddressForm({ name: "address", value: true });
      flag++;
    } else {
      setValidationAddressForm({ name: "address", value: false });
    }
    if (AddressForm.city === "") {
      setValidationAddressForm({ name: "city", value: true });
      flag++;
    } else {
      setValidationAddressForm({ name: "city", value: false });
    }
    if (AddressForm.state === "") {
      setValidationAddressForm({ name: "state", value: true });
      flag++;
    } else {
      setValidationAddressForm({ name: "state", value: false });
    }
    if (AddressForm.pincode === "") {
      setValidationAddressForm({ name: "pincode", value: true });
      flag++;
    } else {
      setValidationAddressForm({ name: "pincode", value: false });
    }

    if (flag === 0) {
      return true;
    } else {
      return false;
    }
  },

  setSelectedAddress: ({ selectedAddress }) => {
    set({ selectedAddress });
  },

  createNewUserAddress: async () => {
    try {
      const { AddressForm, clearAddressForm } = addressStore.getState();
      const res = await axios.post(
        "/site/create-new-user-address",
        AddressForm
      );

      set({ myAddress: res.data.userAddress });
      clearAddressForm();
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  },

  fetchAllUserAddress: async () => {
    try {
      // Fetch user addresses
      const res = await axios.get("/site/fetch-all-user-address");

      // set user address to state
      if (res.data.userAddress && res.data.userAddress.length) {
        set({ myAddress: res.data.userAddress });
      } else {
        set({ myAddress: null });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },

  editFillAddressForm: ({ item }) => {
    set({
      AddressForm: {
        fullName: item.fullName,
        phoneNumber: item.phoneNumber,
        address: item.address,
        city: item.city,
        state: item.state,
        pincode: item.pincode,
        country: item.country,
        addressCategory: item.addressCategory,
        useDefault: item.useDefault,
      },
    });
  },

  updateUserAddress: async ({ _id }) => {
    try {
      const { AddressForm, clearAddressForm } = addressStore.getState();
      const res = await axios.put(
        `/site/update-user-address/${_id}`,
        AddressForm
      );

      set({ myAddress: res.data.userAddress });
      clearAddressForm();
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  },

  removeUserAddress: async ({ _id }) => {
    try {
      const res = await axios.put(`/site/remove-user-address/${_id}`);
      set({ myAddress: res.data.userAddress });
    } catch (error) {
      console.log(error);
    }
  },
}));

export default addressStore;
